export const SEND_MFA = 'login/send_mfa';
export const sendMFA = (data) => ({
  type: SEND_MFA,
  payload: data
});

export const SET_USERNAME = 'login/set_username';
export const setUserName = (data) => ({
  type: SET_USERNAME,
  payload: data
});

export const SEND_MFA_SUCCESS = 'login/send_mfa_success';
export const sendMFASuccess = data => ({
  type: SEND_MFA_SUCCESS,
  payload: data
});

export const SEND_MFA_FAILURE = 'login/send_mfa_failure';
export const sendMFAFailure = () => ({
  type: SEND_MFA_FAILURE
});

export const VERIFY_MFA = 'login/verify_mfa';
export const verifyMFA = data => ({
  type: VERIFY_MFA,
  payload: data
});

export const VERIFY_MFA_SUCCESS = 'login/verify_mfa_success';
export const verifyMFASuccess = (data, cogToken) => ({
  type: VERIFY_MFA_SUCCESS,
  payload: data,
  cogToken: cogToken
});

export const VERIFY_MFA_FAILURE = 'login/verify_mfa_failure';
export const verifyMFAFailure = (resend) => ({
  type: VERIFY_MFA_FAILURE,
  resend: resend
});

export const LOGIN_RESET = 'login/reset';
export const loginReset = () => ({
  type: LOGIN_RESET
});
